
<div class="field-array" *ngIf="field" [class.empty]="!field.content &amp;&amp; !field.rasterized"><span class="inid">{{ field.code || '-' }}</span><span class="label">{{ field.label }}</span>
  <div class="rasterized" *ngIf="field.rasterized; else content"><img [src]="field.rasterized"></div>
  <ng-template #content>
    <ul>
      <li class="content" *ngFor="let x of field.content"><span>{{ x.label }} : {{ x.content }}</span></li>
    </ul>
  </ng-template>
</div>
